import axios from 'axios';
import AnneescolaireService from './AnneescolaireService';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const MATIERE_URL = `${backendUrl}/api/matiere/`;

class MatiereService {
	async getAllMatieres(salledeclasseId = null, anneeScolaireId = null) {
		try {
			// Si anneeScolaireId n'est pas fourni, obtenir l'année scolaire courante
			if (anneeScolaireId === null) {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				anneeScolaireId = schoolYear.data.id;
			}

			// Construire les paramètres de requête
			const params = new URLSearchParams();
			if (salledeclasseId !== null)
				params.append('salledeclasseId', salledeclasseId);

			if (anneeScolaireId !== null)
				params.append('anneeScolaireId', anneeScolaireId);

			// Envoyer la requête au backend avec les paramètres
			const response = await axios.get(MATIERE_URL + 'filter/', { params });

			// Retourner les compétences filtrées directement depuis le backend
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getMatiere(id) {
		return axios.get(`${MATIERE_URL}${id}/`);
	}

	createMatiere(data) {
		return axios.post(MATIERE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du matiere', error);
			throw error;
		});
	}

	updateMatiere(id, data) {
		return axios.put(`${MATIERE_URL}${id}/`, data);
	}

	deleteMatiere(id) {
		return axios.delete(`${MATIERE_URL}${id}/`);
	}

	getMatiereOptions(classId) {
		return this.getAllMatieres(classId).then((matieres) => {
			// Convertir classId en entier
			const classIdInt = parseInt(classId, 10);

			// Si classId est fourni et est un nombre valide, filtrez les matieres pour ne conserver que celles qui contiennent classId dans leur champ classes.
			const filteredMatieres = !isNaN(classIdInt)
				? matieres.filter((matiere) => matiere.classes.includes(classIdInt))
				: matieres;

			return filteredMatieres.map((matiere) => ({
				value: matiere.id,
				label: matiere.nom.toUpperCase(),
				points: matiere[`points_${classId}`] || 0
			}));
		});
	}
}

export default new MatiereService();
